module.exports = __webpack_public_path__ + "static/media/discover-logo.d4f5b087.png";